import { Injectable } from '@angular/core';
import { alert } from 'devextreme/ui/dialog';
import writtenNumber from 'written-number';
@Injectable({
  providedIn: 'root'
})
export class UtilityService {
  constructor() { }

  capitalizza(input: string): string {
    return input
      .toLowerCase()
      .replace(/\b[a-z]/g, (char) => char.toUpperCase());
  }


  async leggiCopiaInMemoria(componentFocus): Promise<string | false> {
    if (!navigator.clipboard || !navigator.clipboard.readText) {
      alert('Il browser non supporta la possibilità di incollare', 'Attenzione');
      return false;
    }
    try {
      window.addEventListener('focus', componentFocus);
      const text = await navigator.clipboard.readText();
      return text
    } catch (e) {
      alert(
        'Non è stato possibile leggere dalla memoria. Controlla le autorizzazioni del browser',
        'Attenzione'
      );
      return false;
    } finally {
      // Rimuovi listener dopo prima esecuzione
      window.removeEventListener('focus', componentFocus);
    }
  }

  async estraiCerListDaStringa(listaCer: string): Promise<boolean | string[]> {
    const msgError = () => {
      alert('Il formato consentito è <strong>xx.xx.xx</strong> oppure <strong>xxxxxx</strong> uniti fra loro oppure separti da spazi e/o linee</p>', 'Formato E.E.R non valido');
      return false
    }
    let stringa: string = listaCer
    if (!listaCer || listaCer === '') {
      return msgError()
    }
    if (stringa.includes('-')) {
      stringa = stringa.split('-').join('')
    }
    if (stringa.includes(' ')) {
      stringa = stringa.split(' ').join('')
    }

    if (stringa.includes('.')) {
      let tmp = stringa.split('.')
      stringa = tmp.map((x, index) => {
        if (x.length < 2 || x.length === 3) {
          return false
        } else if (x.length === 4 && (index + 1) === tmp.length) {
          return false
        } else {
          return x
        }
      }).join('')
    }
    return /^[0-9]{6,}$/.test(stringa) ? this.splitPerLunghezza(stringa, 6) : msgError()
  }

  splitPerLunghezza(stringa: string, nChar: number): string[] {
    const risultato: string[] = []
    if (!stringa || stringa === '') {
      return [stringa]
    }
    for (let i = 0; i < stringa.length; i += nChar) {
      risultato.push(stringa.substring(i, i + nChar));
    }
    return risultato
  }

  allPromise(
    promises: Promise<unknown>[]
  ): Promise<
    {
      status: "completata" | "rifiutata";
      value: any | null;
      error: any | null;
    }[]
  > {
    return Promise.all(
      promises.map((p): Promise<{ status: "completata" | "rifiutata"; value: any | null; error: any | null }> =>
        p
          .then((value): { status: "completata"; value: any; error: null } => ({
            status: "completata",
            value: value,
            error: null,
          }))
          .catch((error): { status: "rifiutata"; value: null; error: any } => ({
            status: "rifiutata",
            value: null,
            error: error,
          }))
      )
    );
  }
  /**ritorna un oggetto appiattito dove le chiavi annidate appaiono così: 'perentKey.key.subkey' */
  flattenObject(
    obj: any,
    parentKey = '',
    result: any = {}
  ): any {
    for (const key in obj) {
      if (!obj.hasOwnProperty(key)) continue;

      const newKey = parentKey ? `${parentKey}.${key}` : key;
      const value = obj[key];

      if (
        typeof value === 'object' &&
        value !== null &&
        !Array.isArray(value)
      ) {
        this.flattenObject(value, newKey, result);
      } else {
        result[newKey] = value;
      }
    }
    return result;
  }

  //Trasforma un file da base64 a oggetto file
  base64ToFileObj(base64String: string, filename: string, ext?: string): File {
    // Gestione stringa vuota: ritorna un file vuoto
    const name = ext ? filename + ext : filename
    if (!base64String || base64String.trim() === '') {
      return new File([], name, { type: 'application/octet-stream' });
    }
    const [metadata, base64Data] = base64String.split(',');
    // Estrazione del MIME type
    const mimeMatch = metadata.match(/data:(.*?);base64/);
    const mime = mimeMatch ? mimeMatch[1] : 'application/octet-stream';
    // Decodifica Base64 → Uint8Array
    const binaryString = atob(base64Data);
    const byteArray = new Uint8Array(binaryString.length);
    for (let i = 0; i < binaryString.length; i++) {
      byteArray[i] = binaryString.charCodeAt(i);
    }
    // Creazione del File
    return new File([byteArray], name, { type: mime });
  }

  //Converte le query:  ?idsede=$idsede   oppure   ?$filter=(idsede eq $idsede)
  //In:  ?idsede=1   oppure   ?$filter=(idsede eq 1)
  convertiFiltroDinamico(filtro: string, dati: { [key: string]: any }) {
    if (filtro.includes('$filter=')) {
      // CASO ODATA
      return filtro.replace(/\$([a-zA-Z0-9_]+)/g, (_, match) => {
        const value = dati[match];
        return value !== undefined ? value : `$${match}`;
      });
    } else {
      // CASO QUERY STRING STANDARD
      const params = filtro.split('?')[1].split('&');
      const resolvedParams = params.map(param => {
        const [key, val] = param.split('=');
        if (val.startsWith('$')) {
          const variable = val.substring(1);
          const resolved = dati[variable];
          return `${key}=${resolved !== undefined ? resolved : val}`;
        } else {
          return `${key}=${val}`;
        }
      });
      return `?${resolvedParams.join('&')}`;
    }
  }

  numeroInLetterePrezzo(valore) {
    writtenNumber.defaults.lang = 'it';
    const [interi, decimaliRaw] = valore.split(',');
    const numeroLettere = writtenNumber(parseInt(interi, 10));
    const decimali = decimaliRaw.padEnd(2, '0');
    return `${numeroLettere}/${decimali}`;
  }

  async toBase64(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = () => resolve(reader.result as string);
      reader.onerror = error => reject(error);

      reader.readAsDataURL(file);
    });
  }

  async toPureBase64(file: File): Promise<string> {
    return await this.toBase64(file).then(res => res.split(',')[1]);
  }

  splitCamelCase(str: any): string {
    if (!str) return '';
    str = String(str);
    return str
      .replace(/([a-z])([A-Z])/g, '$1 $2')
      .replace(/([A-Z]+)([A-Z][a-z])/g, '$1 $2')
      .replace(/([0-9])([A-Za-z])/g, '$1 $2')
      .replace(/([A-Za-z])([0-9])/g, '$1 $2')
      .trim();
  }
  capitalizeWords(sentence: string) {
    if (!sentence || typeof sentence !== "string") return "";

    return sentence
      .split(" ")
      .map(word => {
        if (word.length === 0) return word;
        return word.charAt(0).toUpperCase() + word.slice(1);
      })
      .join(" ");
  }

}
